import React from 'react';
import Datacenter from './Datacenter';
import { iMachineProps } from './Machine';
import { getMachineDcGroups } from './util';
import './MachineList.css';



interface iMachineListProps {
  machines: iMachineProps[];
}
class MachineList extends React.Component<iMachineListProps> {


  render() {

    const groupedMachines = getMachineDcGroups(this.props.machines)

    return <div className="leftAndRightLists">
      {Object.keys(groupedMachines).sort().map((groupName: string)=>{
        const machines = groupedMachines[groupName];
        return <Datacenter key={groupName} machines={machines} name={groupName}/>
      })}
    </div>
  }
}

export default MachineList;
